import type {RankingBadgeVariant} from "./get_ranking_badge_for_offer";

import recognized2025 from "../assets/badges_2025/recognized_2025.svg";
import second2025 from "../assets/badges_2025/second_2025.svg";
import third2025 from "../assets/badges_2025/third_2025.svg";
import winner2025 from "../assets/badges_2025/winner_2025.svg";

/** Extend with a new year key after adding `badges_YYYY/` assets and imports. */
const RANKING_BADGE_SRC_BY_YEAR: Partial<Record<number, Record<RankingBadgeVariant, string>>> = {
    2025: {
        winner: winner2025,
        second: second2025,
        third: third2025,
        recognized: recognized2025
    }
};

export function getRankingBadgeImageSrc(year: number, variant: RankingBadgeVariant): string | undefined {
    return RANKING_BADGE_SRC_BY_YEAR[year]?.[variant];
}
import type {RankingBadgeVariant} from "./get_ranking_badge_for_offer";

import recognized2025 from "../assets/badges_2025/recognized_2025.svg";
import second2025 from "../assets/badges_2025/second_2025.svg";
import third2025 from "../assets/badges_2025/third_2025.svg";
import winner2025 from "../assets/badges_2025/winner_2025.svg";

/** Extend with a new year key after adding `badges_YYYY/` assets and imports. */
const RANKING_BADGE_SRC_BY_YEAR: Partial<Record<number, Record<RankingBadgeVariant, string>>> = {
    2025: {
        winner: winner2025,
        second: second2025,
        third: third2025,
        recognized: recognized2025
    }
};

export function getRankingBadgeImageSrc(year: number, variant: RankingBadgeVariant): string | undefined {
    return RANKING_BADGE_SRC_BY_YEAR[year]?.[variant];
}
